module.exports = __webpack_public_path__ + "img/panel7.8ff85423.svg";